export const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL; 
export const GoogleMapApiKey = process.env.NEXT_PUBLIC_GOOGLEMAPSECRETEKEY;
// export const SESSION_SECRET_KEY = process.env.SESSION_SECRET_KEY;
// export const BACKEND_URL = process.env.BACKEND_URL